import View from "../common/utils/IFrameResizerLight";
import components from "./components.js";
components.define("js-iframe-resizer", View);